import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  shareContainer: {
    paddingTop: "10px",
  },
  shareContainerWithBorder: {
    paddingTop: "10px",
    "&:after": {
      content: "",
      left: 0,
      top: "14.5rem",
      position: "absolute",
      width: "100%",
      height: "1px",
      background: "#ddd",
    },
  },
  list: {
    color: theme.palette.blue.darkShade1,
    listStyle: "none",
    padding: 0,
    margin: "8px",
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    alignItems: "center",
  },
  listItem: {
    width: "40px",
    height: "40px",
    "&:last-child .react-share__ShareButton": {
      marginRight: 0,
    },
  },
  shareButton: {
    width: "40px",
    height: "40px",
    overflow: "hidden",
    borderRadius: "50%",
    minHeight: "32px",
    marginRight: "15px",
    outline: "none",
    "&:hover": {
      cursor: "pointer",
    },
    boxShadow: `0px 3px 5px -1px rgba(0, 0, 0, 0.2),
      0px 6px 10px 0px rgba(0, 0, 0, 0.14),
      0px 1px 18px 0px rgba(0, 0, 0, 0.12)`,
  },
  svgIcon: {
    color: theme.palette.events.blueSecondary,
    "&:hover": {
      color: theme.palette.events.blue,
    },
  },
}));
